module.exports = __webpack_public_path__ + "static/media/Yrsa-SemiBold.69ae60a2.ttf";